// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2GZXB","list":"PatternAutocomplete_list__22PVg"};